import React, { useState, useEffect } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { logout } from "../../redux/actions/authActions";

const initialHotels = [
  { name: "The Royal Orchid", place: "Jaipur", score: 94 },
  { name: "Blue Lagoon Resort", place: "Goa", score: 92 },
  { name: "Grand Palace Inn", place: "Delhi", score: 90 },
  { name: "Mountain View Retreat", place: "Manali", score: 89 },
  { name: "Luminous Stay", place: "Hyderabad", score: 87 },
  { name: "Hotel Emerald Bay", place: "Kochi", score: 86 },
  { name: "The Heritage Crown", place: "Udaipur", score: 85 },
  { name: "Sunrise Suites", place: "Pune", score: 84 },
  { name: "Skyline Residency", place: "Bengaluru", score: 83 },
  { name: "Hotel Silver Sands", place: "Chennai", score: 82 },
];

const initialRestaurants = [
  { name: "Spice Symphony", place: "Delhi", score: 95 },
  { name: "Taste of Tuscany", place: "Mumbai", score: 93 },
  { name: "Curry Junction", place: "Pune", score: 91 },
  { name: "Urban Bites", place: "Bengaluru", score: 89 },
  { name: "GreenLeaf Bistro", place: "Chandigarh", score: 87 },
  { name: "Zaika House", place: "Lucknow", score: 86 },
  { name: "Golden Grill", place: "Kolkata", score: 85 },
  { name: "The Food Factory", place: "Hyderabad", score: 84 },
  { name: "The Chef’s Table", place: "Ahmedabad", score: 83 },
  { name: "Royal Rasoi", place: "Jaipur", score: 82 },
];

const initialCafeterias = [
  { name: "Cafe Aroma", place: "Mumbai", score: 93 },
  { name: "Brew & Bean", place: "Pune", score: 91 },
  { name: "Caffeine Corner", place: "Delhi", score: 89 },
  { name: "Mocha Moments", place: "Bengaluru", score: 88 },
  { name: "Java Junction", place: "Chandigarh", score: 87 },
  { name: "Bean & Leaf", place: "Hyderabad", score: 85 },
  { name: "Brew Republic", place: "Kolkata", score: 84 },
  { name: "Urban Grind", place: "Ahmedabad", score: 83 },
  { name: "Latte Lounge", place: "Indore", score: 82 },
  { name: "Cafe Cascade", place: "Goa", score: 90 },
];

const SakshamHorecaScorecard = () => {
  const { isLoggedIn, user } = useSelector((state) => state.authReducer);
  const [userName] = useState(user?.name || "Guest");
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [activeTab, setActiveTab] = useState("Hotels");
  const [rankings, setRankings] = useState([]);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const handleLogout = () => {
    dispatch(logout());
    navigate("/");
  };

  const shuffleAndSelectTop = (data) => {
    const shuffled = [...data]
      .sort(() => 0.5 - Math.random())
      .slice(0, 10)
      .sort((a, b) => b.score - a.score)
      .map((item, index) => ({ rank: index + 1, ...item }));
    setRankings(shuffled);
  };

  useEffect(() => {
    let dataSource;
    if (activeTab === "Hotels") dataSource = initialHotels;
    else if (activeTab === "Restaurants") dataSource = initialRestaurants;
    else dataSource = initialCafeterias;

    shuffleAndSelectTop(dataSource);
    const interval = setInterval(() => shuffleAndSelectTop(dataSource), 5000);
    return () => clearInterval(interval);
  }, [activeTab]);

  const today = new Date().toLocaleDateString("en-IN", {
    day: "numeric",
    month: "long",
    year: "numeric",
  });

  return (
    <div className="flex flex-col min-h-screen font-sans text-white bg-black ">
      <header className="flex justify-between items-center px-4 py-1 bg-black shadow-md sticky top-0 z-50 border-b border-green-500">
        <div
          onClick={() => navigate("/rankings")}
          className="text-lg lg:text-xl font-bold text-yellow-200 tracking-wide cursor-pointer"
        >
          🍽 SAKSHAM HORECA Rankings
        </div>

        <div className="hidden md:flex items-center space-x-2">
          {isLoggedIn && (
            <>
              <span className="text-white font-medium">{userName}</span>
              <button
                onClick={handleLogout}
                className="w-8 h-8 mt-2 flex items-center justify-center text-lg bg-green-500 text-white rounded-full hover:bg-green-600 transition sm:w-9 sm:h-9"
                title="Logout"
              >
                ⏻
              </button>
            </>
          )}
        </div>
        <button
          onClick={() => setIsMobileMenuOpen((s) => !s)}
          className="md:hidden mt-2 w-8 h-8 flex items-center justify-center text-xl bg-green-700 text-white"
          aria-label="Toggle menu"
        >
          {isMobileMenuOpen ? "×" : "☰"}
        </button>        
      </header>

      {/* MOBILE MENU */}
      {isMobileMenuOpen && (
        <nav className="md:hidden bg-green-700 flex flex-col px-4 py-3 space-y-3">
          {isLoggedIn && (
            <div className="border-t pt-3 border-green-500 text-white">
              <p className="mb-2 text-sm">{userName}</p>
              <button
                onClick={handleLogout}
                className="bg-green-500 text-white mt-4 px-4 py-2 rounded text-sm hover:bg-green-600 w-full transition"
              >
                Logout
              </button>
            </div>
          )}
        </nav>
      )}

      <div className="grid grid-cols-3 justify-center gap-1 mt-2 place-items-center">
        {["Hotels 🏨", "Restaurants 🍽️", "Cafeterias ☕"].map((tab) => {
          const key = tab.split(" ")[0];
          return (
            <button
              key={key}
              onClick={() => setActiveTab(key)}
              className={`px-4 py-2 rounded-lg font-semibold transition ${
                activeTab === key
                  ? "bg-teal-600 text-white shadow-lg"
                  : "bg-cyan-600 text-white hover:bg-cyan-800"
              }`}
            >
              {tab}
            </button>
          );
        })}
      </div>

      <main className="flex-1 bg-black text-white p-4 overflow-y-auto">
        <div className="text-center mb-2">
          <p className="text-white font-medium">{today}</p>
          <h2 className="text-lg lg:text-xl font-bold">
            🏅 {activeTab} Leaderboard 
          </h2>
        </div>

        <div className="overflow-x-auto bg-black rounded-lg shadow-md">
          <table className="min-w-full text-sm lg:text-m">
            <thead className="bg-cyan-600 text-white uppercase text-xs lg:text-sm">
              <tr>
                <th className="py-2 px-3 border">Rank</th>
                <th className="py-2 px-4 border">{activeTab} Name</th>
                <th className="py-2 px-4 border">Place</th>
                <th className="py-2 px-3 border">Score</th>
              </tr>
            </thead>
            <tbody>
              {rankings.map(({ rank, name, place, score }) => (
                <tr
                  key={name}
                  className="text-left hover:bg-gray-500 text-black transition-all"
                >
                  <td className="py-2 px-2 border text-center">{rank}</td>
                  <td className="py-2 px-2 border">{name}</td>
                  <td className="py-2 px-2 border">{place}</td>
                  <td className="py-2 px-2 border text-center font-semibold">
                    {score}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </main>

      <footer className="bg-black border-t border-green-400 text-white py-2 px-4 mt-2">
        <div className="flex flex-col md:flex-row justify-between items-center text-center md:text-left space-y-4 md:space-y-0">
          <p className="text-xs sm:text-sm">&copy; 2025 Think5Whys Global DeepTech Solutions.</p>
          <div className="flex flex-row gap-2 sm:gap-6 text-xs sm:text-sm">
            <Link to="/about-us" className="text-white hover:text-green-200 transition">About</Link>
            <Link to="/privacy-policy" className="text-white hover:text-green-200 transition">Privacy Policy</Link>
            <Link to="/terms-of-use" className="text-white hover:text-green-200 transition">Terms of Use</Link>
            <Link to="/contact-us" className="text-white hover:text-green-200 transition">Contact</Link>
          </div>
        </div>
      </footer> 
    </div>
  );
};

export default SakshamHorecaScorecard;
